module.exports = __webpack_public_path__ + "img/steering-wheel-outline-grey.eb06d4ba.svg";